import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var getAwsRegionExtensionConfiguration = function getAwsRegionExtensionConfiguration(runtimeConfig) {
  var runtimeConfigRegion = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var region;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(runtimeConfig.region === undefined)) {
                _context.next = 2;
                break;
              }
              throw new Error("Region is missing from runtimeConfig");
            case 2:
              region = runtimeConfig.region;
              if (!(typeof region === "string")) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", region);
            case 5:
              return _context.abrupt("return", region());
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function runtimeConfigRegion() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    setRegion: function setRegion(region) {
      runtimeConfigRegion = region;
    },
    region: function region() {
      return runtimeConfigRegion;
    }
  };
};
export var resolveAwsRegionExtensionConfiguration = function resolveAwsRegionExtensionConfiguration(awsRegionExtensionConfiguration) {
  return {
    region: awsRegionExtensionConfiguration.region()
  };
};